import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { RestrictionModel, RestrictionAuditHistoryModel, RestrictReasonType, RestrictionReasonModel } from 'src/models/restriction.model';

@Injectable({
  providedIn: 'root'
})
export class RestrictionService {

  apiUrl = AppConfig.appsettings.apiRoot;
  constructor(private http: HttpClient) { }

  getRestrictsApplicantDetails(): Observable<RestrictionModel[]> {
      return this.http.get<RestrictionModel[]>(this.apiUrl + '/GetRestrictsApplicantDetails')
      .pipe(catchError(this.handleError));
  }
  
  getRestrictionDetails(restrictApplicantId: number): Observable<any> {
    const params = new HttpParams().set('restrictApplicantId', restrictApplicantId.toString());
    return this.http.get<any>(this.apiUrl + '/GetRestrictionDetailsById', { params })
    .pipe(catchError(this.handleError));
  }
  
  createOrUpdateRestriction(model: RestrictionModel): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/CreateOrUpdateRestriction', model)
      .pipe(catchError(this.handleError));
  }

  getRestrictionReasonTypes(): Observable<RestrictReasonType[]> {
    return this.http.get<RestrictReasonType[]>(this.apiUrl + '/GetRestrictionReasonTypes')
      .pipe(catchError(this.handleError));
  }

  getRestrictionReasons(restrictApplicantId: number): Observable<RestrictionReasonModel[]> {
    const params = new HttpParams().set('restrictApplicantId', restrictApplicantId.toString());
    return this.http.get<RestrictionReasonModel[]>(this.apiUrl + '/GetRestrictionReasons', { params })
      .pipe(catchError(this.handleError));
  }

  saveRestrictionReasons(applicantCommunicationNote: RestrictionReasonModel): Observable<number> {
     return this.http.post<number>(this.apiUrl + '/SaveRestrictionReasons',applicantCommunicationNote )
    .pipe(catchError(this.handleError));    
  }

  getRestrictionAuditHistory(restrictApplicantId: number): Observable<RestrictionAuditHistoryModel[]> {
    const params = new HttpParams().set('restrictApplicantId', restrictApplicantId.toString());
    return this.http.get<RestrictionAuditHistoryModel[]>(this.apiUrl + '/GetRestrictionAuditHistory', { params })
      .pipe(catchError(this.handleError));
  }


  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }
}
